import axios from "axios";

export const baseURL = process.env.REACT_APP_BASE_URL;

export const KEY_USER = "@painel-orca:user";
export const KEY_AUTH = "@painel-orca:auth";

export const api = axios.create({
	baseURL: `${baseURL}api`,
	headers: { "Content-Type": "application/json" },
});

api.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (error.response?.status === 401) {
			localStorage.clear();
			sessionStorage.clear();
			window.location.replace("/login");
		}
		return Promise.reject(error.response);
	},
);

export const setAuthorization = (token: string | null): void => {
	api.defaults.headers.common["Authorization"] = token;
};
